module.exports = __webpack_public_path__ + "img/help.02c93c94.svg";